module.exports = __webpack_public_path__ + "img/Ocean.f0f618fe.jpg";